import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-inline-date-picker',
    templateUrl: './inline-date-picker.component.html',
    styleUrls: ['./inline-date-picker.component.scss'],
    standalone: false
})
export class InlineDatePickerComponent implements OnInit {
  @Input() data: string;
  @Input() disabledFlag: boolean;
  @Input() defaultPlaceHolder: string;
  @Input() templateEdit: boolean;
  @Input() truncate: number = 100000;
  @Input() isValueDate: boolean = true;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();

  tempValue: any;
  dataDate: Date;

  editMode = false;
  constructor() {}

  ngOnInit() {
    this.tempValue = this.data;
    if(this.data == null) {
      this.dataDate = new Date();
    } else {
      this.dataDate = new Date(this.data);
    }
    if(!this.defaultPlaceHolder){
      this.defaultPlaceHolder = "--/--/----";
    }
  }
  onClose() {
    this.editMode = false;
  }
  onFocusOut() {
    this.editMode = false;
    this.data = this.convertDate(this.dataDate);
    this.focusOut.emit( this.data );
  }
  convertDate(date: Date) {
    let month = date.getMonth() + 1;
    return month + "/" + date.getDate() + "/" + date.getFullYear();
  }
  dateSet(dateString) {
    if(!dateString) {
      return new Date().toISOString();
    }
    if(!this.isValidDate(dateString)) return String();
    return (new Date(dateString)).toISOString();
  };

  isValidDate(dateString) {
    let d = new Date(dateString);
    return d instanceof Date && !isNaN(d.getDate());
  }
  undo() {
    this.editMode = false;
    this.data = this.tempValue;
    //todo make it undo the changes
  }
}
